function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m166.023 112.557 30.13-8.81 7.435 30.499 5.585 22.907 27.614-48.009c4.262-7.409 11.739-11.115 19.217-11.115 7.468 0 14.936 3.696 19.202 11.091l65.848 114.15-42.538 24.568 121.008 35.363 29.843-122.486-42.687 24.654-85.049-147.435c-13.689-23.744-38.224-37.925-65.631-37.934h-.025c-27.396 0-51.931 14.166-65.63 37.892l-46.712 81.212z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m501.34 349.12-47.11-81.62-12.991 53.303-52.628-15.38 27.898 48.337c8.54 14.78-2.13 33.25-19.19 33.25h-131.9v-49.21l-91.14 87.1 91.14 87.1v-49.21h170.29c27.4 0 51.93-14.16 65.63-37.89 13.701-23.73 13.701-52.06.001-75.78z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m77.319 462.791h93.183l-16.952-16.201-22.69-21.69 22.69-21.69 16.954-16.203h-55.81c-17.067 0-27.732-18.477-19.196-33.255l66.156-114.542 42.649 24.624-29.861-122.482-121.003 35.38 42.583 24.585-85.363 147.798c-13.743 23.804-13.699 52.241.134 76.014 13.704 23.554 39.276 37.662 66.526 37.662z"
}));

var SvgRecycle = function SvgRecycle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 20,
    viewBox: "0 0 512 512",
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecycle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recycle.73fbba44.svg";
export { ForwardRef as ReactComponent };